export enum Repeat {
  NoRepeat = 'no-repeat',
  Custom = 'custom',
  Daily = 'daily',
  Weekly = 'weekly',
  Weekday = 'weekday',
  Monthly = 'monthly',
  Yearly = 'yearly',
  Day = 'day',
  WeekendDay = 'weekend-day',
}

export enum Days {
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA',
  SU = 'SU',
}

export const defaultDueInInMinutes = 2 * 60;
